"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_TIMEOUT = void 0;
var DEFAULT_TIMEOUT = 60000;
exports.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.5051/js/internal/Constants.js
// module id = 551
// module chunks = 5 6